module.exports = __webpack_public_path__ + "static/media/france-2.883fd472.svg";